import { RationComponent } from '../../shared/models/models';

export interface MeasurementsState {
  measurementOverview: MeasurementSummary[];
  measurement: Measurement;
}

export interface MeasurementSummary {
  id: number;
  name: string;
  type: Type;
  averageParticleLength: number;
  created: string;
  dmPercentage: number;
  ndf: number;
  'peNDF1.18': number;
  peNDF8: number;
  stickiness: number;
  species?: Species;
  rationType?: RationType;
  hoursAfterFeeding?: string;
}

export interface Measurement {
  id?: number;
  name?: string;
  type?: Type;
  productType?: ProductType;
  silageMethod?: SilageMethod;
  rationType?: RationType;
  species?: Species;
  createdBy?: string;
  updatedBy?: string;
  creationDate?: string;
  lastModifiedDate?: string;
  shipToId?: number;
  relatedMeasurementId?: number;
  hoursAfterFeeding?: string;
  input?: MeasurementInput;
  analyses?: MeasurementAnalysis[];
  output?: MeasurementOutput;
}

export enum Type {
  Product = 'Product',
  Ration = 'Ration',
  Restfeed = 'Restfeed',
}

export enum ProductType {
  Grass = 'Grass',
  Maize = 'Maize',
  Straw = 'Straw',
}

export interface Ration {
  name: string;
  type: RationType;
}

export enum Species {
  MilkCow = 'MilkCow',
  DryCow = 'DryCow',
  YoungStock = 'YoungStock',
}

export enum RationType {
  Pmr = 'Pmr',
  Tmr = 'Tmr',
}

export enum SilageMethod {
  Chopped = 'Chopped',
  LoaderWagon = 'LoaderWagon',
}

export interface MeasurementInput {
  dmPercentage: number;
  ndf: number;
  dmMaizeKilograms?: number;
  dmGrassKilograms?: number;
  structureBasalRation?: number;
  freshGrassBasalRation?: number;
  basalRationAmount?: number;
  freshGrassAmount?: number;
  concentrateAmount?: number;
  componentLoadingOrder?: ComponentLoadingOrder[];
  mixingTime?: number;
}

export interface ComponentLoadingOrder {
  component: RationComponent;
  order: number;
}

export interface MeasurementAnalysis {
  type: AnalysisType;
  sieveA?: MeasurementAnalysisValue;
  sieveB?: MeasurementAnalysisValue;
  sieveC?: MeasurementAnalysisValue;
  containerD?: MeasurementAnalysisValue;
  total?: number;
  totalWithGrassAndConcentrate?: number;
}

export enum AnalysisType {
  Fresh = 'Fresh',
  Dry = 'Dry',
}

export interface MeasurementAnalysisValue {
  grams: number;
  percentage?: number;
  percentageNoGrass?: number;
  percentageNoConcentrate?: number;
  gramsWithGrass?: number;
  gramsWithConcentrate?: number;
}

export interface MeasurementOutput {
  stickiness: number;
  averageParticleLength: number;
  peNDF8: number;
  'peNDF1.18': number;
}
